"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const immutable_1 = require("immutable");
const compose_1 = __importDefault(require("utils/compose"));
const uuid_1 = require("uuid");
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const react_1 = require("@emotion/react");
const material_1 = require("@mui/material");
const react_use_1 = require("react-use");
const react_router_1 = require("react-router");
const query_string_1 = __importDefault(require("query-string"));
const scheduledTransactionsTypes_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsTypes");
const scheduledTransactionsUtils_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsUtils");
const Helmet_1 = __importDefault(require("components/Helmet"));
const UIState_1 = __importDefault(require("components/UIState"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const SelectTransactionDialog_1 = __importDefault(require("components/Dialogs/SelectTransactionDialog"));
const scheduledTransactionsUtils_2 = require("data/scheduledTransactions/scheduledTransactionsUtils");
const helpers_1 = require("containers/OverviewPage/components/helpers");
const AmountField_1 = __importStar(require("components/QuickenControls/AmountField"));
const ScheduledTransactionFormView_1 = __importDefault(require("components/ScheduledTransactions/ScheduledTransactionFormView"));
const ScheduledTransactionFormQuicken_1 = __importDefault(require("components/ScheduledTransactions/ScheduledTransactionFormQuicken"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const styles_1 = __importDefault(require("./styles"));
const useSelectOrDispatch_1 = require("./useSelectOrDispatch");
const ScheduledTxnsAppBar_1 = __importDefault(require("./ScheduledTxnsAppBar"));
const LoadingAndEmptyScheduledTxnsViews_1 = __importDefault(require("./LoadingAndEmptyScheduledTxnsViews"));
const utils_1 = require("./utils");
const ScheduledTransactions = (props) => {
    const { classes, theme, uiState, setUIState } = props;
    const [addMenu, setAddMenu] = React.useState(null);
    const [editMode, setEditMode] = React.useState(false);
    const [discardCb, setDiscardCb] = React.useState(undefined);
    const [isFormDirty, setIsFormDirty] = React.useState(false);
    const [sortDueDate, setSortDueDate] = React.useState(false);
    const [globalSearch, setGlobalSearch] = React.useState(undefined);
    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = React.useState(false);
    const [showSelectTransactionDialog, setShowSelectTransactionDialog] = React.useState(false);
    const [isTransfer, setIsTransfer] = React.useState(false);
    const location = (0, react_router_1.useLocation)();
    const { tags, isLoading, isDataEmpty, loadPending, upcomingTxns, accountsById, noDependencies, categoriesById, allUpcomingTxns, scheduledTransaction, scheduledTransactions, existingScheduledTransaction, scheduledTransactionsEnabled, sharedAccounts, isEntityGroupEnabled, dispatchDoAccountDiscoveryAction, dispatchDoWFBillsScoutBillIncomeFlow, dispatchCreateBillScoutScheduleAction, dispatchGetScheduledTransactionsAction, } = (0, useSelectOrDispatch_1.useData)(props);
    (0, react_use_1.useEffectOnce)(() => {
        if (!isLoading) {
            dispatchGetScheduledTransactionsAction();
        }
        const query = query_string_1.default.parse(location.search);
        const scheduledTxn = query.selectNode && { id: query.selectNode };
        setUIState({ scheduledTransaction: scheduledTxn });
    });
    React.useEffect(() => {
        if (editMode) {
            return;
        }
        const { filterTab } = uiState;
        const prevScheduledTxn = uiState === null || uiState === void 0 ? void 0 : uiState.scheduledTransaction;
        const selectedScheduledTxn = scheduledTransactions.find((sTxn) => (sTxn === null || sTxn === void 0 ? void 0 : sTxn.id) === (prevScheduledTxn === null || prevScheduledTxn === void 0 ? void 0 : prevScheduledTxn.id));
        // When stType is changed from income to bill or vice-versa or it's deleted from QWin/QMac then hide the view secton.
        if (!selectedScheduledTxn || ((prevScheduledTxn === null || prevScheduledTxn === void 0 ? void 0 : prevScheduledTxn.type) !== (selectedScheduledTxn === null || selectedScheduledTxn === void 0 ? void 0 : selectedScheduledTxn.type) && filterTab !== 'all')) {
            setUIState({ scheduledTransaction: null });
        }
    }, [scheduledTransactions, uiState, setUIState, editMode]);
    const sliderActive = Boolean(scheduledTransaction);
    const view = (0, helpers_1.computeViewState)(() => isLoading, () => isDataEmpty, noDependencies, loadPending, !scheduledTransactionsEnabled);
    const changeDetailsMode = () => setEditMode(!editMode);
    const selectTransaction = (transaction) => {
        const clientId = (0, uuid_1.v4)().toUpperCase();
        if (transaction && transaction.id) {
            dispatchCreateBillScoutScheduleAction({ clientId, id: transaction.id });
        }
        setShowSelectTransactionDialog(false);
        setUIState({
            scheduledTransaction: {
                clientId,
                recurrence: {},
                transaction: { amount: 0 },
            },
        });
        changeDetailsMode();
    };
    const setDirtyForm = (isFormDirtyFlag) => setIsFormDirty(isFormDirtyFlag);
    const showConfirmationDialog = (isConfirmationDialogOpenParam, discardCbParam) => {
        setIsConfirmationDialogOpen(isConfirmationDialogOpenParam);
        setDiscardCb(discardCbParam);
    };
    const closeSchTxnForm = () => {
        setUIState({ scheduledTransaction: undefined });
        setEditMode(false);
        setDirtyForm(false);
    };
    const onAddClick = () => {
        const { filterTab } = uiState;
        if (filterTab === scheduledTransactionsTypes_1.STTypeEnum.TRANSFER) {
            // TRANSFER ONLY
            setShowSelectTransactionDialog(true);
            setIsTransfer(true);
        }
        else {
            // ALL | BILL | INCOME tabs
            setIsTransfer(false);
            dispatchDoWFBillsScoutBillIncomeFlow({
                initialStep: (0, utils_1.findInitialValueForBillsScout)(filterTab),
                singleStep: !(filterTab === 'all'),
                hideAddManually: true,
                addManualST: selectTransaction,
            });
        }
    };
    const renderHeader = () => (<>
      <Helmet_1.default title="Bills and Income"/>
      <material_1.AppBar position="sticky" color="inherit" elevation={0} className={classes.appBarTitle}>
        <material_1.Toolbar className={classes.toolbar}>
          <material_1.ListItemText primary="Bills and Income" primaryTypographyProps={{ variant: 'h6', className: classes.title }} secondaryTypographyProps={{ variant: 'subtitle1' }} secondary="Manage your recurring payments"/>
        </material_1.Toolbar>
        <material_1.Divider />
      </material_1.AppBar>
    </>);
    const renderAppBar = () => <ScheduledTxnsAppBar_1.default {...props} sliderActive={sliderActive} isFormDirty={isFormDirty} setIsFormDirty={setIsFormDirty} sortDueDate={sortDueDate} setSortDueDate={setSortDueDate} globalSearch={globalSearch} setGlobalSearch={setGlobalSearch} editMode={editMode} setEditMode={setEditMode} setIsConfirmationDialogOpen={setIsConfirmationDialogOpen} setDiscardCb={setDiscardCb} addMenu={addMenu} setAddMenu={setAddMenu} selectTransaction={selectTransaction} onAddClick={onAddClick}/>;
    const renderRow = (scheduledTxn, key = null) => {
        const uiTxn = scheduledTransaction;
        const selectedRow = (0, utils_1.isScheduledTxnSelected)(scheduledTxn, uiTxn);
        const upTxn = allUpcomingTxns.get(scheduledTxn && scheduledTxn.id);
        const schTxn = (0, scheduledTransactionsUtils_2.userFriendlyTxnNames)(scheduledTxn, categoriesById, isEntityGroupEnabled ? sharedAccounts : accountsById, (upTxn && upTxn.first()));
        const { isDue, isOverdue, showLabel } = (0, utils_1.getScheduledTxnDueState)(scheduledTxn.dueOn);
        return (<>
        <RendersCount_1.default id={`scTxnRow-${scheduledTxn.clientId || scheduledTxn.id}`}/>
        <material_1.TableRow key={scheduledTxn.clientId || scheduledTxn.id} id={`scheduled-txn-${key}`} selected={selectedRow} hover onClick={() => {
                if (!selectedRow && !isFormDirty) {
                    setUIState({ scheduledTransaction: scheduledTxn.toJS() });
                }
                else if (isFormDirty) {
                    showConfirmationDialog(isFormDirty, () => {
                        setUIState({ scheduledTransaction: scheduledTxn.toJS() });
                        setDirtyForm(false);
                    });
                }
                else {
                    closeSchTxnForm();
                }
            }} className={(0, classnames_1.default)(classes.standardRow, { [classes.rowSticky]: selectedRow, [classes.displayTable]: !!uiTxn })} classes={{ selected: classes.shadedRow }}>
          <material_1.TableCell className={classes.tableCellAvatar}>
            <material_1.Avatar className={(0, classnames_1.default)(classes.avatar, (schTxn && schTxn.type && (scheduledTransactionsUtils_1.STTypeNamesEnum[schTxn.type] || schTxn.type).toLowerCase()))}>
              {((scheduledTxn.transaction || {}).payee || '')[0]}
            </material_1.Avatar>
          </material_1.TableCell>

          <material_1.TableCell className={(0, classnames_1.default)(classes.tableCellPayee, classes.ellipseTextWrap)}>
            <div className={(0, classnames_1.default)(classes.payeeCellRoot, { [classes.payeeCellRootPadding]: showLabel })}>
              <QTip_1.default title={schTxn.payeeName} wrapOnly>
                <material_1.Typography variant="body1" id={`scheduled-txn-${key}-name`} className={classes.ellipsedText}>
                  {schTxn.payeeName}
                </material_1.Typography>
              </QTip_1.default>
              <material_1.Typography variant="caption" id={`scheduled-txn-${key}-next-instance-date`} 
        // color="secondary"
        className={classes.ellipsedText}>
                {schTxn.nextDateFormatted}
              </material_1.Typography>
              {showLabel && ((isOverdue && <span className={classes.overdueLabel}>OVERDUE</span>) ||
                (isDue && <span className={classes.dueLabel}>DUE</span>))}
            </div>
          </material_1.TableCell>

          {!uiTxn &&
                <material_1.TableCell className={(0, classnames_1.default)(classes.tableCellAccount, classes.ellipseTextWrap)}>
            <QTip_1.default title={schTxn.accountName} wrapOnly>
              <material_1.Typography variant="body1" id={`scheduled-txn-${key}-source-account`} className={classes.ellipsedText}>
                {schTxn.accountName}
              </material_1.Typography>
            </QTip_1.default>
            <material_1.Typography variant="caption" id={`scheduled-txn-${key}-account-type`} 
                // color="secondary"
                className={classes.ellipsedText}>
              {schTxn.subtype}
            </material_1.Typography>
          </material_1.TableCell>}

          {!uiTxn &&
                <material_1.TableCell className={(0, classnames_1.default)(classes.tableCellCategory, classes.ellipseTextWrap)}>
            <QTip_1.default title={schTxn.category} wrapOnly>
              <material_1.Typography variant="body1" id={`scheduled-txn-${key}-category`} className={classes.ellipsedText}>
                {schTxn.category}
              </material_1.Typography>
            </QTip_1.default>
            <material_1.Typography variant="caption" id={`scheduled-txn-${key}-type`} 
                // color="secondary"
                className={classes.ellipsedText}>
              {scheduledTransactionsUtils_1.STTypeNamesEnum[schTxn.type] || schTxn.type}
            </material_1.Typography>
          </material_1.TableCell>}

          <material_1.TableCell className={(0, classnames_1.default)(classes.tableCellAmount, { [classes.selectedArrow]: selectedRow })}>
            <material_1.ListItemText primary={<AmountField_1.default showSign={AmountField_1.ShowSignEnum.POSITIVE_ONLY} showColor={AmountField_1.ShowColorEnum.POSITIVE_ONLY} value={schTxn.amount} className={classes.amtText} id={`scheduled-txn-${key}-amount`}/>} secondary={schTxn.frequency} secondaryTypographyProps={{
                variant: 'caption',
                id: `scheduled-txn-${key}-frequency`,
            }}/>
          </material_1.TableCell>
        </material_1.TableRow>
      </>);
    };
    const schTxnsToRender = (0, utils_1.getScheduledTxnsToRender)({
        scheduledTransactions,
        filterTab: uiState.filterTab,
        sortDueDate,
        globalSearch,
        allUpcomingTxns,
        categoriesById,
        accountsById,
        tags,
    });
    const renderTable = () => (<div className={classes.root}>
      {!editMode &&
            <material_1.Paper className={classes.rootPaper}>
          <material_1.Table className={classes.rootTable}>
            <material_1.TableBody className={classes.tableBod}>
              {scheduledTransaction && !scheduledTransaction.id && renderRow(scheduledTransaction)}
              {schTxnsToRender && schTxnsToRender.map((schTxn, key) => renderRow(schTxn, key))}
            </material_1.TableBody>
          </material_1.Table>
        </material_1.Paper>}
      {sliderActive &&
            <material_1.Paper className={classes.schTxnForm}>
          {!editMode && existingScheduledTransaction && (<>
                <div className={classes.shadowBar}/>
                <ScheduledTransactionFormView_1.default key={(scheduledTransaction || {}).id} changeDetailsMode={changeDetailsMode} scheduledTransaction={scheduledTransaction || {}} onClose={closeSchTxnForm} upcomingTxn={upcomingTxns}/>
              </>)}
          {editMode && (<ScheduledTransactionFormQuicken_1.default key={(scheduledTransaction || {}).id} discardCb={discardCb} changeDetailsMode={changeDetailsMode} scheduledTransaction={scheduledTransaction || {}} label={(scheduledTransaction || {}).id ? 'Edit Series' : 'Add New Series'} showCloseButton onClose={closeSchTxnForm} showConfirmationDialog={showConfirmationDialog} isConfirmationDialogOpen={isConfirmationDialogOpen} setDirtyForm={setDirtyForm} isFormDirty={isFormDirty} selectedTab={uiState === null || uiState === void 0 ? void 0 : uiState.filterTab}/>)}
        </material_1.Paper>}
    </div>);
    return (<material_1.Typography component="div" className={classes.floorStyle}>
      {renderHeader()}
      {(view === helpers_1.ViewStateEnum.EMPTY || view === helpers_1.ViewStateEnum.MAIN) && renderAppBar()}
      {view !== helpers_1.ViewStateEnum.MAIN &&
            <LoadingAndEmptyScheduledTxnsViews_1.default dispatchDoAccountDiscoveryAction={dispatchDoAccountDiscoveryAction} view={view}/>}
      {view === helpers_1.ViewStateEnum.MAIN && renderTable()}
      <SelectTransactionDialog_1.default open={showSelectTransactionDialog} onClose={() => setShowSelectTransactionDialog(false)} onTransactionSelected={selectTransaction} selectorProps={{ isTransfer }}/>
    </material_1.Typography>);
};
const ScheduledTransactionsUIState = (0, immutable_1.Record)({
    filterTab: 'all',
    scheduledTransaction: undefined,
});
const uiStateConfig = {
    persist: true,
    name: () => 'ScheduledTransactions',
    state: () => new ScheduledTransactionsUIState(),
};
exports.default = (0, compose_1.default)((0, UIState_1.default)(uiStateConfig), react_1.withTheme)((0, mui_1.withStyles)(ScheduledTransactions, styles_1.default));
